import { API } from "@thenounproject/lingo-core";
import { createAsyncAction } from "../actionCreators";

type Args = {
  spaceId: number;
  newOwnerId: number;
};

const [useTransferSpace, transferSpace] = createAsyncAction(
  "spaces/transferSpace",
  async ({ spaceId, newOwnerId }: Args) => {
    const res = await API.call<{ space: number }>({
      endpoint: `spaces/${spaceId}/transfer`,
      method: "POST",
      data: { user_id: newOwnerId },
    });
    return { ...res, result: res.result.space };
  }
);
export default useTransferSpace;
export { transferSpace };
